export function normalizeCountryCodeForClientSDK(
    countryCode: string,
): 'US' | 'CA' {
    return countryCode.toUpperCase() as 'US' | 'CA';
}

export function normalizeLangToLocaleForServiceCall(
    locale: string,
    countryCode: string,
    province: string | undefined,
): string {
    const normalizedLocale = locale.replace('-', '_');
    return countryCode.toLowerCase() === 'ca' &&
        province &&
        ['qc'].includes(province?.toLowerCase())
        ? `${normalizedLocale}_${province.toUpperCase()}`
        : normalizedLocale;
}

export function normalizeZipCodeForComparison(zipCode: string): string {
    return zipCode.replace(/\s/g, '').toUpperCase();
}

export function normalizeVinForServiceCall(vin: string): string {
    return vin.toUpperCase();
}

/**
 * Atlas API is case-sensitive for radioId.
 * All production radioId values should be in uppercase.
 * Test radioId UUID values are to remain lowercase.
 * @param radioId
 */
export function normalizeRadioIdForServiceCallWithSupportForUUID(
    radioId: string,
): string {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        radioId,
    )
        ? radioId
        : radioId.toUpperCase();
}
